import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { memo, useState } from 'react';
import { IdentityCardVM } from 'front-office/view-models/reprint-cid/form';
import Form from './form';
import { FormikErrors, FormikTouched } from 'formik';

interface AccordionIdentityCardProps {
  onChange: (key: keyof IdentityCardVM, value: IdentityCardVM[keyof IdentityCardVM]) => void;
  values?: IdentityCardVM;
  touched?: FormikTouched<IdentityCardVM>;
  errors?: FormikErrors<IdentityCardVM>;
}

const AccordionIdentityComponent = ({
  onChange,
  values,
  errors,
  touched,
}: AccordionIdentityCardProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-content"
        id="panel-person-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>{"Dati carta d'identità"}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Form values={values} onChange={onChange} errors={errors} touched={touched} />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionIdentityComponent.displayName = 'Accordion Identity Card';

const AccordionIdentity = memo(AccordionIdentityComponent);

export default AccordionIdentity;
